import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'kkis-app-webshop-menu-section1',
    templateUrl: './menu-section1.component.html',
    styleUrls: ['./menu-section1.component.scss']
})
export class MenuSection1Component implements OnInit {

    // Search
    search: string = "";

    // Utils
    isLoading: boolean = true;

    constructor(
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.isLoading = false;
    }

    onReload() {
        window.location.href = '/';
    }

    onSearch() {
        if (this.search) {
            this.router.navigate(['/articles'], {
                queryParams: {
                    search: this.search,
                }
            });
        }
    }
}
